module.exports = __webpack_public_path__ + "img/rate.930abbb7.png";